import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogData } from 'src/app/models/dialog-data';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { BePosto } from 'src/app/models/BePosto';
import { SubService } from 'src/app/services/sub.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ListaDadosColuna } from 'src/app/components/lista-dados/lista-dados.component';

@Component({
  selector: 'app-list-postos',
  templateUrl: './list-postos.component.html',
  styleUrls: ['./list-postos.component.css']
})
export class ListPostosComponent implements OnInit, OnDestroy {
  public postos: BePosto[] = [];
  public colunasListaDados: ListaDadosColuna[] = [
    {
      campo: 'noPosto',
      rotulo: 'Posto',
      tamanho: '30%',
      editavel: true,
      edicao: {
        tipoEditor: 'texto',
        validacao: {
          obrigatorio: true,
          minLength: 3,
          maxLength: 50
        }
      }
    },
    {
      campo: 'dsEndereco',
      rotulo: 'Endereço',
      tamanho: '40%',
      editavel: true,
      edicao: {
        tipoEditor: 'texto',
        validacao: {
          obrigatorio: true,
          minLength: 3,
          maxLength: 100
        }
      }
    },
    {
      campo: 'noReduzido',
      rotulo: 'Nome Reduzido',
      tamanho: '18%',
      editavel: true,
      edicao: {
        tipoEditor: 'texto',
        validacao: {
          obrigatorio: true,
          minLength: 3,
          maxLength: 50
        }
      }
    }
  ];
  public subscription?: Subscription;

  public constructor(
    private httpClient: HttpClient,
    private sub: SubService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
  ) { }

  public ngOnInit(): void {
    this.subscription = this.httpClient.get<BePosto[]>(`/api/Postos`).subscribe({
      next: (res) => {
        this.unsubscribe();
        this.postos = res ?? [];
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe();
  }

  public onSalvarLinha(posto: BePosto): void {
    this.unsubscribe();

    const payload: any = {
      idPosto: posto.idPosto ?? null,
      noPosto: (posto.noPosto ?? '').trim(),
      dsEndereco: (posto.dsEndereco ?? '').trim(),
      noReduzido: (posto.noReduzido ?? '').trim(),
    };

    const requisicao = payload.idPosto
      ? this.httpClient.put<unknown>(`/api/Postos`, payload)
      : this.httpClient.post<BePosto>(`/api/Postos`, payload);

    this.subscription = requisicao.subscribe({
      next: (res: any) => {
        this.unsubscribe();
        if (!payload.idPosto && res?.idPosto) {
          posto.idPosto = res.idPosto;
        }
        posto.noPosto = payload.noPosto;
        posto.dsEndereco = payload.dsEndereco;
        posto.noReduzido = payload.noReduzido;
        this.postos = [...this.postos];
        this.snackBarService.exibirSucesso(payload.idPosto ? 'Registro salvo!' : 'Registro criado!');
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }
  
  public onDelete(posto: BePosto) {
    this.showDialog('Deseja excluir esse registro?', 'Alerta', 'Não', 'Sim', posto);
  }

  public showDialog(msg: string, statusMsg: string, button: string = 'OK', secondButton: string = '', posto: BePosto = {} as BePosto) {
    if (this.subscription)
      return;
    const dialogData: DialogData = {
      title: statusMsg,
      message: msg,
      buttonText: button,
      secondButtonText: secondButton,
    };
    const dialogRef = this.dialog.open(DialogComponent, { data: dialogData });
    dialogRef.afterClosed().subscribe((result) => {
      this.unsubscribe();
      if (result) {
        this.sub.reset(this.httpClient.delete(`/api/Postos/${posto.idPosto}`),
          () => this.onDeleteConfirm(posto),
          () => this.showDialog('Não foi possível excluir o registro!', 'Erro')
        );
      }
    })
  }

  private onDeleteConfirm(res: BePosto) {
    this.postos = this.postos.filter(posto => (posto.idPosto !== res.idPosto));
    this.snackBarService.exibirSucesso('Registro excluído!');
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }

}
